<h1 mat-dialog-title *ngIf="!isLoading" xmlns="http://www.w3.org/1999/html" class="event-edit-features__title">Edit Event Features</h1>
<div id="spinnerContainer" *ngIf="isLoading">
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</div>
<div *ngIf="!isLoading">
  <mat-dialog-content [formGroup]="formGroup">
  <fieldset class="event-edit-features__form-section">
    <legend class="event-edit-feature__form-section-title">Event Features</legend>
    <div style="display: flex; flex-direction: column; gap: 1em; padding: 1em 0 2em 0">
      <mat-checkbox formControlName="isValidated" color="primary">Event Validated</mat-checkbox>
      <mat-checkbox formControlName="isFeatured" color="primary">Featured Event</mat-checkbox>
      <mat-checkbox formControlName="hasAopaPresence" color="primary">AOPA Presence at Event</mat-checkbox>
      <mat-checkbox formControlName="isAopaHosted" color="primary">AOPA Hosted Event</mat-checkbox>
    </div>
  </fieldset>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
